module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens13-e280ab28c74fb5f01516f936f6ce9db8.jpg";